const ROUTES_PATH = {
  LOG_IN: "/login",
  DASHBOARD: "/home",
};
export default ROUTES_PATH;
